// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SwGI","col":"styles_col__3JNGP","actions":"styles_actions__1jFhA","conflict":"styles_conflict__7yyKa"};